<template>
<div>
    <h1>Customer's due payment next (0) days</h1>
</div>
</template>

<script setup>

</script>